import { render, staticRenderFns } from "./svgInstagram.vue?vue&type=template&id=7dfb25d6&scoped=true"
import script from "./svgInstagram.vue?vue&type=script&lang=js"
export * from "./svgInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb25d6",
  null
  
)

export default component.exports